export default (state = [], action) => {
  if (action.type === 'set_socket') {
    return { ...action };
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/utils/socketReducer.js